<template>
  <v-avatar v-on="$listeners" v-bind="$attrs" color="#add8e6">
    <v-img v-if="image" aspect-ratio="1" contain :src="image"></v-img>
    <span class="name" v-else>{{ name | reduceToInitials }}</span>
  </v-avatar>
</template>

<script>
export default {
  inheritAttrs: false,
  props: {
    image: {
      type: String,
      default: null,
    },
    name: {
      type: String,
      required: true,
    },
  },
};
</script>

<style scoped>
.name {
  /* font-size: 1.25rem; */
  font-weight: 700;
}
</style>
